<div
  [ngClass]="{ 'bucket': page, 'bucket-item': !page }"
  class="radius-8"
  id="SharedSearchContainer"
  (click)="closePanel()"
  >
  <form id="SharedSearchform" class="d-flex" [formGroup]="searchDataForm">
    <div class="flexCenterAlign">
      <div class="a-s-b panel-1">
        <i class="icon-ic-Search searchIconSearch"></i>
      </div>
      <div class="flex-wrap panel-2">
        <mat-form-field
          class="formField"
          [ngClass]="{'m-b-s': '(searchDataForm.controls.Name.errors?.maxlength ||
          searchDataForm.controls.Name.errors?.minlength) &&
        isSearchClicked'}"
          >
          <mat-label> Name </mat-label>
          <input matInput #Name name="Name" formControlName="Name"
            [attr.id]="buildSearchId('fld-name')" />
            @if (
              (searchDataForm.controls.Name.errors?.maxlength ||
              searchDataForm.controls.Name.errors?.minlength)
              ) {
              <mat-error
                matTooltipClass="tooltip-style"
                matTooltipPosition="below"
                appMatTooltip="Must be greater than 3 and less than 100 characters"
                class="error text-overflow-ellipsis"
                [attr.id]="buildSearchId('err-name-length')"
                >
                Must be greater than 3 and less than 100 characters</mat-error
                >
            }
          </mat-form-field>

          <div
            class="formField"
            >
            <app-multi-select-dropdown
              [idPrefix]="buildSearchId('ddl-bucket')"
              [selectedItems]="bucketListSelected"
              [items]="bucketList"
              floatLabel="Bucket"
              [requiredLabel]="true"
              [selectFormControl]="bucket"
              (selectionChanged)="validateItems()"
              (click)="this.addCustomValidation(false)"
              >
            </app-multi-select-dropdown>
            @if (searchDataForm.controls.Bucket.errors?.atLeastOneSelected) {
              <mat-error
                class="error-dropdown"
                [attr.id]="buildSearchId('err-bucket-required')"
                >
                Please select at least one Bucket</mat-error
                >
              }
            </div>

            <div
              class="formField"
              >
              <app-multi-select-dropdown
                class="width"
                [idPrefix]="buildSearchId('ddl-bu')"
                [selectedItems]="buListSelected"
                [items]="buList"
                floatLabel="Business Unit"
                [selectFormControl]="bu"
                (selectionChanged)="validateItems()"
                (clearOptions)="onBusinessUnitCleared()"
                >
              </app-multi-select-dropdown>
              @if (
                !isValidBuBucket
                ) {
                <mat-error
                  class="bu-validation-error text-overflow-ellipsis"
                  [attr.id]="buildSearchId('err-bu-invalid')"
                  >
                  <span
                    class="bu-validation-tooltip-trigger"
                    appMatTooltip="BU can not be considered for Study Data Collection"
                    matTooltipClass="tooltip-style"
                    matTooltipPosition="below"
                    >BU can not be considered for Study Data Collection</span
                    ></mat-error
                  >
                }
              </div>

              <mat-form-field class="formField dateField">
                <mat-label>Study Completion Date</mat-label>
                <mat-date-range-input
                  id="DatePicker3"
                  [rangePicker]="picker3"
                  [max]="MaxDate"
                  >
                  <input
                    formControlName="StudyCompletionDateFrom"
                    class="startDate"
                    matStartDate
                    placeholder="dd-mmm-yyyy"
                    [attr.id]="buildSearchId('fld-study-completion-from')"
                    />
                    <input
                      formControlName="StudyCompletionDateTo"
                      matEndDate
                      placeholder="dd-mmm-yyyy"
                      [attr.id]="buildSearchId('fld-study-completion-to')"
                      />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker3"
                      [attr.id]="buildSearchId('tgl-study-completion-date')"
                      >
                      <img
                        matDatepickerToggleIcon
                        src="./assets/images/application-logos/svg/ic-calendar.svg"
                        />
                      </mat-datepicker-toggle>
                      <mat-date-range-picker #picker3></mat-date-range-picker>
                      @if (
                        searchDataForm.controls.StudyCompletionDateFrom.errors
                        ?.startDateGreater
                        ) {
                        <mat-error
                          class="error"
                          >
                          Start date must be less than End date</mat-error
                          >
                      }
                      @if (
                        searchDataForm.controls.StudyCompletionDateFrom.errors
                        ?.specialCharacterError || searchDataForm.controls.StudyCompletionDateTo.errors
                        ?.specialCharacterError
                        ) {
                        <mat-error
                          class="error"
                          >
                          Please enter a valid date</mat-error
                          >
                        }
                      </mat-form-field>

                      <mat-form-field class="formField dateField m-0" >
                        <mat-label>Created Between</mat-label>
                        <mat-date-range-input
                          id="DatePicker1"
                          [rangePicker]="picker1"
                          [max]="MaxDate"
                          >
                          <input
                            formControlName="CreatedBetweenFrom"
                            class="startDate"
                            matStartDate
                            placeholder="dd-mmm-yyyy"
                            [attr.id]="buildSearchId('fld-created-between-from')"
                            />
                            <input
                              formControlName="CreatedBetweenTo"
                              matEndDate
                              placeholder="dd-mmm-yyyy"
                              [attr.id]="buildSearchId('fld-created-between-to')"
                              />
                            </mat-date-range-input>
                            <mat-datepicker-toggle
                              matSuffix
                              [for]="picker1"
                              [attr.id]="buildSearchId('tgl-created-between-date')"
                              >
                              <img
                                matDatepickerToggleIcon
                                src="./assets/images/application-logos/svg/ic-calendar.svg"
                                />
                              </mat-datepicker-toggle>
                              <mat-date-range-picker #picker1></mat-date-range-picker>
                              @if (
                                searchDataForm.controls.CreatedBetweenFrom.errors
                                ?.startDateGreater
                                ) {
                                <mat-error
                                  class="error"
                                  >
                                  Start date must be less than End date</mat-error
                                  >
                              }
                              @if (
                                searchDataForm.controls.CreatedBetweenFrom.errors
                                ?.specialCharacterError || searchDataForm.controls.CreatedBetweenTo.errors
                                ?.specialCharacterError
                                ) {
                                <mat-error
                                  class="error"
                                  >
                                  Please enter a valid date</mat-error
                                  >
                                }
                              </mat-form-field>

                              @if (toDisplay) {
                                <div
                                  class="w-100 p-t-s flexCenterAlign expanded-line gapbetween expanded-search-form"
                                  >
                                   <mat-form-field
            class="formField"
            [ngClass]="{'m-b-s': '(searchDataForm.controls.Path.errors?.maxlength ||
          searchDataForm.controls.Path.errors?.minlength) &&
        isSearchClicked'}"
            >
            <mat-label> Path </mat-label>
            <input matInput #Path name="Path" formControlName="Path"
              [attr.id]="buildSearchId('fld-path')" />
              @if (
                (searchDataForm.controls.Path.errors?.maxlength ||
                searchDataForm.controls.Path.errors?.minlength)
                ) {
                <mat-error
                  matTooltipClass="tooltip-style"
                  matTooltipPosition="below"
                  appMatTooltip="Must be greater than 3 and less than 255 characters"
                  class="error text-overflow-ellipsis"
                  [attr.id]="buildSearchId('err-path-length')"
                  >
                  Must be greater than 3 and less than 255 characters</mat-error
                  >
              }
            </mat-form-field>

                                  <div
                                    class="panel-container formField Panel-margin tags-right-spacing"
                                    (click)="openPanel($event)"
                                    [attr.id]="buildSearchId('btn-open-tags-panel')"
                                    >
                                    <mat-expansion-panel
                                      [ngClass]="{ 'padding-main-panel-1': panelOpenState, 'padding-main-panel-2': !panelOpenState }"
                                      [(expanded)]="panelOpenState"
                                      (closed)="panelClose()"
                                      (opened)="panelOpen()"
                                      >
                                      <mat-expansion-panel-header class="header-padding">
                                        @if (isTagsShow) {
                                          <mat-label class="p-left color-grey"
                                            >Tags</mat-label
                                            >
                                          }
                                          @if (!isTagsShow) {
                                            <span class="width">
                                              <mat-label class="color-grey font-s">Tags</mat-label>
                                              <mat-select-trigger class="tags-preview">
                                                @if (displaySelectedTags[0] ? true : false) {
                                                  <span
                                                    class="multiselect_tag_tags"
                                                    matTooltipClass="tooltip-style"
                                                    matTooltipPosition="above"
                                                    matTooltip="{{ displaySelectedTags[0] }}"
                                                    [attr.id]="buildSearchId('lbl-tags-primary-preview')"
                                                    >
                                                    {{ displaySelectedTags[0] }}
                                                  </span>
                                                }
                                                @if (displaySelectedTags[1] ? true : false) {
                                                  <span
                                                    class="example-additional-selection-tags"
                                                    (click)="overlaydisplay(displaySelectedTags, $event)"
                                                    [attr.id]="buildSearchId('btn-tags-overlay')"
                                                    >
                                                    +{{ displaySelectedTags.length - 1 }} more
                                                  </span>
                                                }
                                              </mat-select-trigger>
                                            </span>
                                          }
                                        </mat-expansion-panel-header>
                                        <ng-template matExpansionPanelContent>
                                          @for (column of masterTags; track column; let i = $index) {
                                            <div>
                                              <div class="innerExpansionPanel">
                                                <mat-expansion-panel
                                                  [selectFormControl]="bu"
                                                  class="tags-panel moreFilters-list"
                                                  >
                                                  <mat-expansion-panel-header
                                                    class="mat-expansion-panel-header tr.mat-row"
                                                    >
                                                    <mat-panel-title>{{ column.TagKey }} </mat-panel-title>
                                                  </mat-expansion-panel-header>
                                                  <hr class="separatorLine" />
                                                  @if (column.TagKey !== 'Year Of Last Entry') {
                                                    <div
                                                      class="multiSelectClearButton"
                                                      >
                                                      <button
                                                        mat-button
                                                        color="accent"
                                                        class="w-100"
                                                        (click)="clearSearchWithData(column, $event)"
                                                        [attr.id]="buildSearchId('btn-clear-tag-group', column.TagKey)"
                                                        >
                                                        Clear
                                                      </button>
                                                    </div>
                                                  }
                                                  @if (column.TagKey === 'Year Of Last Entry') {
                                                    <div
                                                      class="multiSelectClearButton"
                                                      >
                                                      <button
                                                        mat-button
                                                        color="accent"
                                                        class="w-100"
                                                        (click)="clearYearOfEntry($event)"
                                                        [attr.id]="buildSearchId('btn-clear-year-of-entry')"
                                                        >
                                                        Clear
                                                      </button>
                                                    </div>
                                                  }
                                                  @if (column.TagKey === 'File Type') {
                                                    <div class="pb-2">
                                                      <mat-form-field appearance="outline" class="w-100">
                                                        <input matInput (input)="filterTagValues(column, $any($event.target).value)" placeholder="Search" />
                                                        <button mat-icon-button matSuffix aria-label="Clear search"
                                                          (click)="clearSearchInput(column, $event)">
                                                          <i class="icon-ic-remove-doc"></i>
                                                        </button>
                                                      </mat-form-field>
                                                    </div>
                                                  }
                                                  @if (column.TagKey === 'Countries') {
                                                    <div class="pb-2">
                                                      <mat-form-field appearance="outline" class="w-100">
                                                        <input matInput (input)="filterTagValues(column, $any($event.target).value)" placeholder="Search" />
                                                        <button mat-icon-button matSuffix aria-label="Clear search"
                                                          (click)="clearSearchInput(column, $event)">
                                                          <i class="icon-ic-remove-doc"></i>
                                                        </button>
                                                      </mat-form-field>
                                                    </div>
                                                  }
                                                  <div class="enableScroll tagOptionsHeight">
                                                    @for (
                                                      columnValue of column.TagDropDownValues; track
                                                      columnValue; let j = $index) {
                                                      <div
                                                        >
                                                        @if (column.TagKey !== 'Year Of Last Entry') {
                                                          <mat-checkbox
                                                            [(ngModel)]="columnValue.IsSelected"
                                                            [ngModelOptions]="{ standalone: true }"
                          id="shared_filter_chk_{{ column.fieldCode }}-{{
                            columnValue.Code
                          }}"
                                                            name="{{ column.TagKey }}-{{ columnValue.Code }}"
                                                            >
                                                            {{ columnValue.Code }}
                                                          </mat-checkbox>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                  @if (column.TagKey === 'Year Of Last Entry') {
                                                    <div>
                                                      <div class="formField-yearOfLastEntry m-0">
                                                        <app-year-picker
                                                          [tag]="column"
                                                          placeHolder="From"
                                                          (selectedValue)="setTagValueFrom($event)"
                                                          >
                                                        </app-year-picker>
                                                        <div class="between">-</div>
                                                        <app-year-picker
                                                          [tag]="column"
                                                          placeHolder="To"
                                                          (selectedValue)="setTagValueTo($event)"
                                                          >
                                                        </app-year-picker>
                                                      </div>
                                                      @if (invalidYearOfLastEntry) {
                                                        <mat-error
                                                          >
                                                          Please select both the years <br />
                                                          Start year must be less than End year
                                                        </mat-error>
                                                      }
                                                    </div>
                                                  }
                                                </mat-expansion-panel>
                                              </div>
                                            </div>
                                          }
                                        </ng-template>
                                      </mat-expansion-panel>
                                    </div>
                                    <mat-form-field class="formField dateField enddate-spacing"
                                      >
                                      <mat-label>Archiving End Date</mat-label>
                                      <mat-date-range-input
                                        id="DatePicker2"
                                        [rangePicker]="picker2"
                                        [max]="MaxDateForArchivingEnd"
                                        >
                                        <input
                                          formControlName="ArchivingEndDateFrom"
                                          class="startDate"
                                          matStartDate
                                          placeholder="dd-mmm-yyyy"
                                          [attr.id]="buildSearchId('fld-archiving-end-from')"
                                          />
                                          <input
                                            formControlName="ArchivingEndDateTo"
                                            matEndDate
                                            placeholder="dd-mmm-yyyy"
                                            [attr.id]="buildSearchId('fld-archiving-end-to')"
                                            />
                                          </mat-date-range-input>
                                          <mat-datepicker-toggle
                                            matSuffix
                                            [for]="picker2"
                                            [attr.id]="buildSearchId('tgl-archiving-end-date')"
                                            >
                                            <img
                                              matDatepickerToggleIcon
                                              src="./assets/images/application-logos/svg/ic-calendar.svg"
                                              />
                                            </mat-datepicker-toggle>
                                            <mat-date-range-picker #picker2></mat-date-range-picker>
                                            @if (
                                              searchDataForm.controls.ArchivingEndDateFrom.errors
                                              ?.startDateGreater
                                              ) {
                                              <mat-error
                                                class="error"
                                                >
                                                Start date must be less than End date</mat-error
                                                >
                                            }
                                            @if (
                                              searchDataForm.controls.ArchivingEndDateTo.errors
                                              ?.specialCharacterError || searchDataForm.controls.ArchivingEndDateFrom.errors
                                              ?.specialCharacterError
                                              ) {
                                              <mat-error
                                                class="error"
                                                >
                                                Please enter a valid date</mat-error
                                                >
                                              }
                                            </mat-form-field>
                                            <app-autocomplete
                                              [textFormControl]="searchDataForm.controls.CreatedBy"
                                              width=15.5 widthForOptions=24.5 minType=3
                                              floatLabelOnBlur="Uploaded By"
                                              floatLabelOnFocus="Uploaded By"
                                              placeHolder="Uploaded By"
                                              [options]="uploadedByUserInfo"
                                              inputValidationErrorMessage="Please provide valid PUID"
                                              inputPattern='^[a-zA-Z0-9]{3,4}$'
                                              (valueChange)="getUserInfo($event)">
                                            </app-autocomplete>
                                            <div class="include-previous-versions-toggle">
                                              <mat-slide-toggle
                                                color="rgbrgb($app-link-color)"
                                                (change)="toggled = !toggled;"
                                                class="icon-color"
                                                formControlName="includePreviousVersion"
                                                [attr.id]="buildSearchId('tgl-include-previous-versions')"
                                                >
                                                <span class="font-m include-versions-text"> Include previous versions </span>
                                              </mat-slide-toggle>
                                              <div matTooltipClass="tooltip-style" matTooltipPosition="below"
                                                appMatTooltip="Search could be slow when Include previous version is selected"
                                                class="warning-text p-t-xs include-previous-versions-warning"
                                                [class.warning-hidden]="!toggled"
                                                [attr.id]="buildSearchId('msg-include-previous-warning')">
                                                <span class="info-icon cursor">!</span>
                                                Search could be slow when Include previous version is selected
                                              </div>
                                            </div>
                                          </div>
                                        }
                                      </div>
                                      <div class="d-flex pd-t-s a-s-b flexCenterAlign panel-3">
                                        <button
                                          class="ghost pointCursor"
                                          type="button"
          [ngClass]="
            toDisplay
              ? 'icon-ic_arrow_collapse search_btn_search'
              : 'icon-ic_arrow_expand icon-color search_btn_search'
          "
                                          class="icon-ic_arrow_expand icon-color pointCursor"
                                          (click)="toggleData()"
                                          [attr.id]="buildSearchId('btn-toggle-advanced-panel')"
                                        ></button>
                                        <button
                                          type="submit"
                                          mat-button
                                          color="accent"
                                          (click)="onSearchClick()"
                                          class="ghost p-l-p-10 search_btn_search pointCursor"
                                          [attr.id]="buildSearchId('btn-search-submit')"
                                          >
                                          Search
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
